<template>
    <div v-if="allockBox">
        <el-dialog :mode-append-to-body="false" :close-on-click-modal="false" title="分配套餐" center
                   :visible.sync="allockBox" class="class_dialog_hospital" width="70%">

      <span style="font-size:17px;">
        下载模板：
        <a :href="modeAllocPacketUrl" style="">导入划卡模板</a>
      </span>
            <el-form label-width="100px" style="margin-top:15px;">
                <el-form-item label="基于代理分配:">
                    <el-select @focus="loadAgent" clearable filterable allow-create default-first-option v-model="parentId" placeholder="请选择">
                        <el-option v-for="i in agents" :key="i.id" :label="i.agentName" :value="i.agentId"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="目标代理:">
                    <el-select @focus="loadAgent" clearable filterable allow-create default-first-option v-model="agentOneLevel" placeholder="请选择">
                        <el-option v-for="i in agents" :key="i.id" :label="i.agentName" :value="i.agentId"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="资源类型:">
                    <el-select @focus="loadType" clearable filterable allow-create default-first-option v-model="cardType"   placeholder="请选择">
                        <el-option v-for="(item,index) in options" :key="index" :label="item.cardTypeName" :value="item.cardTypeCode">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="主体套餐:">
                    <el-select @focus="loadPackage" clearable filterable allow-create default-first-option v-model="packageId" @change="getPackets(packageId)" placeholder="请选择">
                        <el-option v-for="(item,index) in packages" :key="index" :label="item.packageAgentname" :value="item.packageId">
                        </el-option>
                    </el-select>
                </el-form-item>



                <el-form-item v-if="packets.length>0" label="要分配的套餐：">
                    <el-transfer @change="transdata" :titles="titles" v-model="selPackets" :data="packets"></el-transfer>
                </el-form-item>
                <div v-if="selPacketsShow">
                    <el-form-item   v-for="(item,index) in dangweiInfo" :key="index"  :label="'修改套餐名'+(index+1)" >
                        <el-col :span="8">
                            <el-input v-model.trim="item.newPacketName" type="input"/>
                        </el-col>
                        <el-col :span="10">
                            <span style="margin-left: 5%">前端显示：
                            <el-input style="width: 70%" v-model.trim="item.newPacketWxName" type="input" /></span>
                        </el-col>
                        <el-col :span="6">
                            <div style="margin-left: 5%">
                                <i class="el-icon-circle-plus" @click="addForm(item)"></i>
                                <i v-if="index+1!==1" @click="delForm(item)" class="el-icon-delete-solid"/>
                            </div>
                        </el-col>
                    </el-form-item>
                </div>
                <el-form-item v-if="packets.length>0" label="物联网卡号：">
                    <el-input type="textarea" :rows="10" style="width:100%;" v-model="iccids" placeholder="请输入号码（卡号之间以换行隔开）" />
                </el-form-item>
                <el-form-item label="上传表格：">
                    <el-upload action="#" :disabled="false" ref="upload" style="text-align: center;" class="upload-demo" drag
                               :limit="limitNum" :auto-upload="false" :on-change="fileChange"
                               :http-request="importFile" accept=".xls,.xlsx"
                               :data="{cardType:this.cardType,packets:this.selPackets,agentId:this.agentOneLevel}">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__tip">只能上传xls/xlsx文件</div>
                        <div class="el-upload__text">
                            将文件拖到此处，或
                            <em>点击上传</em>
                        </div>
                    </el-upload>
                </el-form-item>
            </el-form>

            <div style="text-align: center" slot="footer" class="dialog-footer">
                <el-button  style="text-align: center" type="primary" plain size="small" @click="uploadBatchDrawCard(0)">清空分配</el-button>
                <el-button  style="text-align: center" type="primary" plain size="small" @click="uploadBatchDrawCard(1)">叠加分配</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import tools from "../utils/tools";

    export default {
        name: "alloc_package",
        props:{
            diaVisDrawCard:  Boolean,
        },
        data(){
            return {
                roleId: '',
                allockBox: this.diaVisDrawCard,
                modeAllocPacketUrl: this.$modelUrl+'/分配套餐.xlsx',
                agents: [],
                options: [],
                packages: [],
                packets: [],
                selPackets:[],
                selPacketsShow:false,
                agentOneLevel: '',
                parentId:'',
                cardType: '',
                packageId: '',
                iccids: '',
                dangweiInfo:[{
                    newPacketName: '',
                    newPacketWxName: '',
                }],
                titles:['套餐列表','选中套餐'],
                fileList: [],
                limitNum: 1,
                agentjs: require('../api/agent'),
                cardTypeJs: require('../api/cardType'),
                packetjs: require('../api/packet'),
                packageJs:require('../api/package'),
                formData: null,
                file: null,
                logUrl:''
            }
        },
        mounted() {
            this.$emit('allocopen')
            let _this = this
            _this.roleId =_this.$loginUser.roleId
            _this.logUrl = JSON.parse(sessionStorage.getItem('logUrl'))
        },
        methods:{
            delForm(item){
                var index = this.dangweiInfo.indexOf(item)
                if (index !== -1) {
                    this.dangweiInfo.splice(index, 1)
                }
            },
            addForm(item){
                if(item.newPacketName<=0||item.newPacketWxName<=0){
                    this.$alert("请先设置名称再添加档位")
                    return false
                }
                this.dangweiInfo.push({
                    newPacketName: '',
                    newPacketWxName: '',
                })
            },
            loadPackage(){
              this.packages=[]
              this.packageJs.getPackages({cardType:this.cardType}).then(res=>{
                  if(res.data.code==='0'){
                      this.packages = res.data.data
                  }
              })
            },
            getPackets(val) {
                let _this = this
                _this.packets = []
                _this.packageId = val
                //获取代理id
                let map={
                    packageId: val,
                    agentId: _this.parentId,
                    current:1,
                    size:999999,
                }
                //加载当前通道的所有套餐
                _this.packetjs.getPackets(map)
                    .then(res => {
                        if (res.data.code === '0') {
                            let data = res.data.data.rows
                            data.map((item,index)=>{
                                _this.packets.push({
                                    key: item.id,
                                    label: _this.roleId==='777'?item.packetName:item.packetWxName ,
                                    disabled: false
                                })
                            })
                        }
                    })
            },
            transdata(val){
                this.selPackets=val
                this.selPacketsShow=true
            },
            loadAgent(){
                this.agents=[]
                this.agentjs.getSearchAgent(
                    {}).then(res=>{
                    res.data.data.map(item=>{
                        let map={
                            agentId: item.agentId,
                            agentName: item.agentName
                        }
                        this.agents.push(map)
                    })

                })
            },
            loadType() {
                let _this = this
                _this.options=[]
                _this.cardTypeJs.getNeedCardTypeList(_this.parentId).then(response => {
                    _this.options = response.data.data
                })
            },
            fileChange(file,fileList){
                let that=this
                // 这里做一些文件控制，注意：就算一次选取多个文件，这里依旧会执行多次
                let extension = file.name.substring(file.name.lastIndexOf('.') + 1)
                if (extension !== 'xlsx' && extension !== 'xls') {
                    that.$alert('上传文件只能是xls/xlsx 格式！！！')
                    fileList.pop()
                }
                that.fileList = fileList
                that.file = file

            },
            importFile(parms){
              let that= this
                //获取iccids
              let iccids = tools.textareaGet(that.iccids)
              if(iccids.length > 1000 ){
                  that.$alert("最多只能输入1000张卡号")
                 return false
              }
              if(null===parms && iccids.length ===0){
                  that.$alert("请输入号码或上传文件")
                  return false
              }
              that.formData = new FormData()
              if(null!=parms){
                 that.formData.append("file",parms.raw)
              }
              that.formData.append("cardType",that.cardType)
              that.formData.append("agentId",that.agentOneLevel)
              that.formData.append("tcId",that.selPackets)
              return true
            },
            uploadBatchDrawCard(val){
                let that = this
                if(that.cardType===''){
                    that.$alert("请选择卡通道")
                    return false
                }
                if(that.selPackets.length===0){
                    that.$alert("请分配套餐")
                    return false
                }
                let diyNewPacketName=''
                that.dangweiInfo.map(item=>{
                    diyNewPacketName +=item.newPacketName+","
                })
                let diynewPacketWxName=''
                that.dangweiInfo.map(item=>{
                    diynewPacketWxName +=item.newPacketWxName+","
                })

                if(that.importFile(that.file)){
                    that.formData.append("flag",val)
                    that.formData.append("packageId",that.packageId)
                    that.formData.append("parentId",that.parentId)
                    that.formData.append("logUrl",that.logUrl)
                    that.formData.append("newPacketName",diyNewPacketName.substr(0,diyNewPacketName.length-1))
                    that.formData.append("newPacketWxName",diynewPacketWxName.substr(0,diynewPacketWxName.length-1))
                    if(that.file!=null){
                        that.packetjs.allocPacket(that.formData).then(res=>{
                            if(res.data.code==="0"){
                                that.$alert(res.data.data)
                            }else{
                                that.$alert(res.data.msg)
                            }
                            that.diaVisDrawCard = false
                        }).catch(err=>{})
                    }else{
                        let iccids = tools.textareaGet(that.iccids)
                        let data ={
                            cardType: that.cardType,
                            agentId: that.agentOneLevel,
                            tcId: that.selPackets,
                            iccids: iccids,
                            flag: val,
                            packageId: that.packageId,
                            parentId: that.parentId,
                            logUrl: that.logUrl,
                            newPacketName: diyNewPacketName.substr(0,diyNewPacketName.length-1),
                            newPacketWxName: diynewPacketWxName.substr(0,diynewPacketWxName.length-1),
                        }
                        that.packetjs.allocPacketText(data).then(res=>{
                            if(res.data.code==="0"){
                                that.$alert(res.data.data)
                            }else{
                                that.$alert(res.data.msg)
                            }
                            that.diaVisDrawCard = false
                        }).catch(err=>{})
                    }

                }

            },


        }
    }
</script>

<style scoped>

    ::v-deep .el-transfer-panel{
        width: 40%;
    }

</style>